import React from 'react';
import { formatDate } from '@thd-olt-functional/utils';
import { shape, string } from 'prop-types';

export const SEOContent = ({ itemId, productLabel, questionsAnswers }) => {
  const {
    Offset, Includes, Limit, Results, TotalResults
  } = questionsAnswers;
  const nextPage = Offset + Limit > TotalResults
    ? -1
    : Math.ceil((Offset + Limit) / Limit) + 1;

  const { Answers = [], AnswersOrder } = Includes || {};
  return (
    <div className="bv-fallback">
      <div className="bv-fallback__count">
        <span>{TotalResults}</span>
        <span className="bv-fallback__title">Questions</span>
        <span>{(AnswersOrder || []).length}</span>
        <span className="bv-fallback__title">Answers</span>
      </div>
      {(Results || []).map((result, resultIndex) => {
        const {
          AnswerIds, UserNickname, QuestionSummary, SubmissionTime
        } = result;
        const firstAnswerId = AnswerIds.length ? AnswerIds[0] : null;
        const correspondingAnswer = (Answers || []).find((answer) => answer.AnswerId === firstAnswerId);
        const { Answer } = correspondingAnswer || {};

        const submissionDate = SubmissionTime ? new Date(SubmissionTime) : null;
        const dateString = submissionDate ? formatDate({ date: submissionDate }) : '';
        return (
          <div className="bv-fallback__question" key={`fallback-${resultIndex}`}>
            <div className="bv-fallback__question-details">
              <div>
                <h3 className="bv-fallback__title">{QuestionSummary}</h3>
                Asked by <span className="bv-fallback__name">{UserNickname}</span> {dateString}
              </div>
              <div className="bv-fallback__answer-count">
                <div className="bv-fallback__answer-count--bold">
                  {AnswerIds.length}
                </div>
                {AnswerIds.length === 1 ? 'Answer' : 'Answers'}
              </div>
            </div>
            <p className="bv-fallback__answer">{Answer?.AnswerText}</p>
          </div>
        );
      })}
      {nextPage > -1
      && (
        <a
          href={`?bvqap=1999/questions/product/${nextPage}/${itemId}.htm`}
        >
          {productLabel}
          {' '}
          - page
          {' '}
          {nextPage}
        </a>
      )}
    </div>
  );
};

SEOContent.displayName = 'QuestionsAndAnswersSEOContent';

SEOContent.propTypes = {
  itemId: string.isRequired,
  productLabel: string,
  questionsAnswers: shape({}).isRequired
};

SEOContent.defaultProps = {
  productLabel: null
};
